import { BaseAction, ActionType, ActionStatus } from '../common';

/**
 * Represents the navigate action's effect.
 */
export const enum TransactionType {
  TransactionModal = 'TRANSITION_MODAL',
  TransactionPush = 'TRANSITION_PUSH',
  TransactionNone = 'TRANSITION_NONE',
}

/**
 * Represents the navigate action.
 */
export type NavigateAction = BaseAction & {
  /** The type of the action. */
  actionType: ActionType.Navigate;

  options: {
    /** The screenUuid of the action link to. */
    target: string;

    /** The effect of the action. */
    transition?: TransactionType;
  };
};

/**
 * Represents the result of the navigate action.
 */
export type NavigateActionResult = NavigateAction & {
  status: ActionStatus.Pending;
};
